import React, { useEffect } from 'react'
import PageBody from '../../../components/pagebody/PageBody'
import Button from '../../../components/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setClientPayerId, setFilingFee, setRowsPerPage, setSelectedExtensionsList, setSelectedForm, setSelectedPayer, setSelectedStatus, setSelectedYear, setShouldReloadExtensionFormsList, setSkip } from './ManageExtensionFormSlice'
import styles from './ManageExtensionForm.styles'
import Loadable from '../../../components/loadable/Loadable'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import Label from '../../../components/label/Label'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import { deleteForm, downloadForm, getExtensionAmount, getFilterData, getGridData } from './ManageExtensionFormSaga'
import RichGrid from '../../../components/richgrid/RichGrid'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import { BUTTON_TYPE } from '../../../components/button/constants'
import Icons from '../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import General from '../../../../libs/utility/General'
import ConfirmationPopup from '../../../components/popup/confirmationpopup/ConfirmationPopup'
import { useState } from 'react'
import PaymentDrawer from '../../../businesslogic/components/paymentdrawer/PaymentDrawer';
import ManageExtensionDataService from '../../../../services/ManageExtensionDataService'
import { COMMON_EXPORTING_STATES, COMMON_EXPORTING_STATES_MESSAGE_MAP } from '../../constants/constants'
import { isAccessAllowed, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks'
import { PAGE_PERMISSIONS } from '../../dashboard/constants/constant'
import { setShowPaymentNotAllowedPopup } from '../../dashboard/DashboardSlice'
import useTxSearchParams from '../../../../libs/txsearchparams/TxSearchParamsHook'
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook'
import { QUERY_PARAMS } from '../../formssection/constants'
import useFormatTIN from '../../../../libs/customhooks/useFormatTIN'
import { MANAGE_EXTENSION_LOADING_STATES, MANAGE_EXTENSION_LOADING_STATES_MESSAGE_MAP } from './constants'
import { addNotifications } from '../../toaster/ToasterPortalSlice'

export default function ManageExtensionForm() {

    useGarbageCollector(componentKey);
    const { exportFile, loadingState, selectedPayer, filingFee, payerList, yearList, selectedYear, selectedStatus, statusList, formList, selectedForm, clientPayerId, gridData, rowsPerPage, skip, totalData, selectedExtensions, shouldReloadExtensionFormsList } = useSelector((state) => state[componentKey]);
    const [formToDelete, SetFormToDelete] = useState(null);
    const [showPaymentInformation, setShowPaymentInformation] = useState(false);
    const navigate = useTxNavigate();
    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();

    const { permissions } = useUserPermissionsInfo();
    const { formatTIN } = useFormatTIN()

    useEffect(() => {
        dispatch(getFilterData());
    }, [])

    useEffect(() => {
        const urlPayerId = queryParams.get('PayerId');
        const urlTaxYear = queryParams.get('TaxYear');
        const urlStatus = queryParams.get('Status');
        const urlFormType = queryParams.get('FormType');

        if (urlPayerId && payerList) {
            dispatch(setSelectedPayer(payerList?.find(payer => payer.value === urlPayerId) ?? payerList[0]))
        }

        if (urlTaxYear && yearList) {
            dispatch(setSelectedYear(yearList?.find(year => year.value === urlTaxYear) ?? yearList[0]))
        }

        if (urlStatus && statusList) {
            dispatch(setSelectedStatus(statusList?.find(status => status.value === urlStatus) ?? statusList[0]))
        }

        if (urlFormType && formList) {
            const formListForm = formList?.find(form => form.value === urlFormType);
            if (formListForm) {
                dispatch(setSelectedForm(formList?.find(form => form.value === urlFormType)))
            }
        }
    }, [payerList, yearList, statusList, formList])

    useEffect(() => {
        if (selectedPayer?.value) {
            queryParams.set('PayerId', selectedPayer?.value);
        }
        if (selectedYear?.value) {
            queryParams.set('TaxYear', selectedYear?.value);
        }
        if (selectedStatus?.value) {
            queryParams.set('Status', selectedStatus?.value);
        }
        if (selectedForm?.value) {
            queryParams.set('FormType', selectedForm?.value);
        }
        setQueryParams(queryParams);
    }, [selectedPayer, selectedYear, selectedStatus, selectedForm])

    useEffect(() => {
        if (exportFile?.Base64 && exportFile?.Name) {
            General.downloadFile(exportFile.Base64, exportFile.Name, exportFile.MimeType)
        }
    }, [exportFile])

    const handleChangeSelect = (name, selectedOption) => {
        switch (name) {
            case 'payer':
                dispatch(setSelectedPayer(selectedOption))
                break;
            case 'year':
                dispatch(setSelectedYear(selectedOption))
                break;
            case 'form':
                dispatch(setSelectedForm(selectedOption))
                break;
            case 'status':
                dispatch(setSelectedStatus(selectedOption))
        }
    }

    const handleDeleteForm = (row) => {
        SetFormToDelete(row);
    }

    const handleDownloadForm = (row) => {
        dispatch(downloadForm({
            formId: row.EncryptedFormId,
            UserId: row.EncryptedUserId
        }))
    }

    const handleEditForm = (row) => {
        navigate(`/forms/createnew?FormName=Form8809&Year=${selectedYear.value}&FormRecordId=${row.FormId}&${QUERY_PARAMS.ALLOW_PAYER_RECIPIENT_SELECTION}=true`)
    }

    const handleGetGridData = () => {
        if (selectedForm?.value && selectedPayer?.value && selectedYear?.value && selectedStatus?.value) {
            const params = {
                page: (skip / rowsPerPage) + 1,
                pageSize: rowsPerPage,
                payerId: selectedPayer.value,
                taxYear: selectedYear.value,
                FormType: selectedForm.value,
                ClientPayerId: clientPayerId,
                Status: selectedStatus.value,
            }
            dispatch(getGridData(params))
            dispatch(setSelectedExtensionsList([]))
        }
    }

    useEffect(() => {
        if (shouldReloadExtensionFormsList) {
            handleGetGridData();
            setShouldReloadExtensionFormsList(false);
        }
    }, [shouldReloadExtensionFormsList]);

    useEffect(() => {
        handleGetGridData();
    }, [clientPayerId, selectedForm, selectedPayer, selectedYear, selectedStatus])

    const GENERATE_SUMMARY_COLUMNS = [
        {
            field: "payerName",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Payer Name</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.PayerName}</span>
        },
        {
            field: "referenceNo",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Ref No.</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.ReferenceNumber}</span>
        },
        {
            field: "payerTaxId",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Tax ID</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{formatTIN(row.TINType, row.TaxID)}</span>
        },
        {
            field: "extensionFor",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Extension For</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.FormType}</span>
        },
        {
            field: "status",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Status</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.Status}</span>
        },
        {
            field: "isRecipientRequested",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Recipient Requested?</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.IsRecipientReq.toString()}</span>
        },
        {
            field: "createdDate",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Created Date</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.CreatedDate}</span>
        },
        {
            field: "action",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Action</Label>,
            renderLogic: (row, idx) => <div style={styles.actionColumnPadding}>
                {selectedStatus?.label === 'Not Submitted' &&
                    <>
                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => handleEditForm(row)} title={'Edit Form'}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} /></Button>
                        <Loadable currentState={loadingState.state} loadingStates={MANAGE_EXTENSION_LOADING_STATES.EXPORTING_FILE_LOADING} messageMap={MANAGE_EXTENSION_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                            <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => handleDownloadForm(row)} title={'Download Form'}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DOWNLOAD_ICON} /></Button>
                        </Loadable>
                    </>
                }
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => handleDeleteForm(row)} title={'Delete Form'}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DELETE_ICON} /></Button>
            </div>
        },
    ]

    const handleSubmitToIRS = () => {
        if (selectedExtensions.length) {
            dispatch(getExtensionAmount({
                formName: selectedForm.value,
                taxYear: selectedYear.value,
                PayerDtailId: selectedPayer.value,
                formIds: selectedExtensions.map(extensions => extensions.FormId).join(','),
            }))
        }
        else {
            dispatch(addNotifications({ heading: "Error", message: "Please select at least one record" }))
        }
    }

    useEffect(() => {
        if (filingFee === 0) {
            setShowPaymentInformation(false)
        }
        else {
            setShowPaymentInformation(true)
        }
    }, [filingFee])

    return (
        <PageBody>
            <Heading type={HEADING.H1}>Manage Extension</Heading>
            <div style={styles.mainContainer}>
                <Loadable currentState={loadingState.state} loadingStates={MANAGE_EXTENSION_LOADING_STATES.FILTER_LOADING} messageMap={MANAGE_EXTENSION_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                    <div style={styles.filtersRow}>
                        {
                            payerList && selectedPayer &&
                            <div>
                                <Label>Payer</Label>
                                <SelectDropdown
                                    name="payer"
                                    placeHolder="Select Payer"
                                    value={selectedPayer}
                                    onSelectCb={(name, selectedOption) => handleChangeSelect(name, selectedOption)}
                                    isClearable={false}
                                    options={payerList}
                                />
                            </div>
                        }
                        {
                            yearList && selectedYear &&
                            <div>
                                <Label>Tax Year</Label>
                                <SelectDropdown
                                    name="year"
                                    placeHolder="Select Year"
                                    value={selectedYear}
                                    onSelectCb={(name, selectedOption) => handleChangeSelect(name, selectedOption)}
                                    isClearable={false}
                                    options={yearList}
                                />
                            </div>
                        }
                        {
                            statusList && selectedStatus &&
                            <div>
                                <Label>Status</Label>
                                <SelectDropdown
                                    name="status"
                                    placeHolder="Selected Form"
                                    value={selectedStatus}
                                    onSelectCb={(name, selectedOption) => handleChangeSelect(name, selectedOption)}
                                    isClearable={false}
                                    options={statusList}
                                />
                            </div>
                        }
                        {
                            formList && selectedForm &&
                            <div>
                                <Label>Form</Label>
                                <SelectDropdown
                                    name="form"
                                    placeHolder="Selected Form"
                                    value={selectedForm}
                                    onSelectCb={(name, selectedOption) => handleChangeSelect(name, selectedOption)}
                                    isClearable={false}
                                    options={formList}
                                />
                            </div>
                        }
                    </div>
                </Loadable>
                <Loadable currentState={loadingState.state} loadingStates={[MANAGE_EXTENSION_LOADING_STATES.GRID_LOADING, MANAGE_EXTENSION_LOADING_STATES.DELETING_RECORD_LOADING]} messageMap={MANAGE_EXTENSION_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                    <RichGrid
                        data={gridData}
                        columns={GENERATE_SUMMARY_COLUMNS}
                        extractRowKey={(row) => row.FormId}
                        selectable={true}
                        selectedRows={selectedExtensions}
                        onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedExtensionsList(selectedData))}
                        onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedExtensionsList(selectedData))}
                        paginationProps={{
                            skip: skip,
                            take: rowsPerPage,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setRowsPerPage(newTake));
                                dispatch(setSkip(0))
                            },
                            total: totalData,
                            onChange: (take, t) => {
                                dispatch(setRowsPerPage(take));
                                dispatch(setSkip(t))
                            },
                        }}
                    />
                </Loadable>
                {selectedStatus?.label === 'Not Submitted' &&
                    <div style={styles.submitIRS}>
                        <Button onClickCb={() => {
                            if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                                handleSubmitToIRS()
                            } else {
                                dispatch(setShowPaymentNotAllowedPopup(true))
                            }
                        }}>Submit to IRS</Button>
                    </div>
                }
            </div>
            {showPaymentInformation &&
                <PaymentDrawer
                    isOpen={showPaymentInformation}
                    onCloseCb={() => {
                        dispatch(setFilingFee(0))
                    }}
                    fees={{
                        OnlySeparateStatefiling: "false",
                        TotalFilingFee: filingFee,
                        FilingFee: filingFee,
                        USPSFee: "0",
                        TINMatchFee: "0",
                        StateFee: "0",
                        TINCount: "0",
                        StateFilingCount: "0",
                        USPSCount: "0",
                        FormCount: selectedExtensions.length
                    }}
                    filingFeeLabel={`Filing Fee`}
                    paymentServiceFunctionCb={ManageExtensionDataService.extensionPayment}
                    calculateEstimatedTax={true}
                    onPaymentSuccessCb={() => {
                        handleGetGridData();
                    }}
                />
            }
            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Click on proceed to delete form'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={formToDelete !== null}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(deleteForm({
                            formId: formToDelete.EncryptedFormId
                        }));
                        SetFormToDelete(null);
                    },
                    confirmationButtonText: "Confirm",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        SetFormToDelete(null);
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />
        </PageBody>
    )
}